import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporterProcess(agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/quality_control/container/list_export_quality_inspects/agro_exporter_process/${agro_exporter_process_id}`
    );
  },
  fetchContainer(agro_exporter_process_id, container_id) {
    return RequesterV1.get(
      `agro_exporter/quality_control/container/list_templates/agro_exporter_process/${agro_exporter_process_id}/container/${container_id}`
    );
  },
  downloadQualityInspectsRepXlsx({ container_id, quality_template_id }) {
    return RequesterV1.get(
      `agro_exporter/quality_control/container/list_export_quality_inspects/download_quality_inspects_rep_xlsx/${container_id}/${quality_template_id}`,
      { responseType: "blob" }
    );
  },
  fetchExportQualityInspects(
    container_id,
    exporter_process_quality_template_id
  ) {
    return RequesterV1.get(
      `agro_exporter/quality_control/container/list_export_quality_inspects/${container_id}/${exporter_process_quality_template_id}`
    );
  },
  fetchExporterQualityTemplate(
    container_id,
    exporter_process_quality_template_id
  ) {
    return RequesterV1.get(
      `agro_exporter/quality_control/container/list_export_quality_inspects/quality_template/${container_id}/${exporter_process_quality_template_id}`
    );
  }
};
